// src/components/SeoHead.js
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const DEFAULT_TITLE       = 'Marrakech Reserve';
const DEFAULT_DESCRIPTION = 'Discover the magic of Marrakech Reserve – limited‑edition quality & artisanal olive oil.';
const DEFAULT_URL         = 'https://marrakech-reserve.com';
const DEFAULT_TYPE        = 'website';
const DEFAULT_KEYWORDS    = 'Marrakech Reserve, olive oil, high quality olive oil, extra virgin olive oil, artisanal olive oil, Marrakech, Moroccan Olive Oil';

export default function SeoHead({
  title,
  description,
  url,
  type,
  keywords,
  image,
  children,
}) {
  const fullTitle = title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;
  const metaDesc  = description || DEFAULT_DESCRIPTION;
  const metaUrl   = url         || DEFAULT_URL;
  const metaType  = type        || DEFAULT_TYPE;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <meta name="keywords"    content={keywords || DEFAULT_KEYWORDS} />
      <meta name="viewport"    content="width=device-width, initial-scale=1" />
      <link rel="canonical"    href={metaUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type"        content={metaType} />
      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:url"         content={metaUrl} />
      {image && <meta property="og:image" content={image} />}

      {children}
    </Helmet>
  );
}

SeoHead.propTypes = {
  title:       PropTypes.string,
  description: PropTypes.string,
  url:         PropTypes.string,
  type:        PropTypes.string,
  keywords:    PropTypes.string,
  image:       PropTypes.string,
  children:    PropTypes.node,
};

SeoHead.defaultProps = {
  title:       null,
  description: null,
  url:         null,
  type:        null,
  keywords:    null,
  image:       null,
  children:    null,
};
